import { render, staticRenderFns } from "./ResourceBookingStartPage.vue?vue&type=template&id=fd7e77ae"
import script from "./ResourceBookingStartPage.vue?vue&type=script&lang=js"
export * from "./ResourceBookingStartPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports